import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {ChangeEventHandler, CSSProperties, useContext, useState} from "react";
import {HostContext} from "@components/host/HostProvider";
import {GameContext} from "@components/game/GameProvider";
import {THEME} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    contents: {
        display: "flex",
        flexDirection: "column",
        margin: 4
    }
};
export function EmailPasswordSignUp() {
    const game = useContext(GameContext);
    const host = useContext(HostContext);
    const [input, setInput] =
        useState<Record<string, string>>({})
    const handleEmailCancel = () => {
        setInput(input => ({...input, email: "", password: ""}));
    }
    const handleEmailSignup = () => {
        host.signUp("Worker", {
            username: input["email"],
            password: input["password"]
        }).then(() => game.initialiseUserPlayer()).then(() =>
            setInput(input => ({...input, email: "", password: ""}))
        );
    }
    const handleInputChange = (key: string):ChangeEventHandler<HTMLInputElement> =>
        ({target}) =>
            setInput(input => ({...input, [key]: target.value}));
    const emailWellFormed = input["email"]?.match(/\w+@\w+\.\w+/);
    const passwordWellFormed = input["password"]?.length >= 8;
    const cancelEnabled = (input["confirm"] && input["confirm"].length !== 0) ||
        (input["password"] && input["password"].length !== 0) || (input["email"] && input["email"].length !== 0);

    return (
        <div style={styles.contents}>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="AuthenticationLabelEmail"/>
                </div>
                <input autoComplete="username" onChange={handleInputChange("email")}
                       style={styles.input} value={input["email"] || ""}/>
            </div>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="AuthenticationLabelPassword"/>
                </div>
                <input autoComplete="new-password" onChange={handleInputChange("password")}
                       style={styles.input} type="password" value={input["password"] || ""}/>
            </div>
            <div style={styles.buttons}>
                <button disabled={! cancelEnabled} onClick={handleEmailCancel} style={styles.button}>
                    <LocalisedTypography content="AuthenticationCancel"/>
                </button>
                <button disabled={!emailWellFormed || !passwordWellFormed}
                        onClick={handleEmailSignup} style={styles.button}>
                    <LocalisedTypography content="AuthenticationSignUp"/>
                </button>
            </div>
        </div>
    );
}